/*
 * Ryan O'Dowd
 * 2019-05-28
 * © Copyright 2019 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import {
  Image,
  Linking,
  TouchableOpacity,
  View,
} from 'react-native';
import Legal from './Legal';
import React from 'react';
import Text from '@components/common/Text';
import {
  format as dateFnsFormat,
} from 'date-fns';
import getStyles from './styles';
import hooks from '@hooks';

const Footer = () => {
  const styles = hooks.useStyles(getStyles);
  const locationState = hooks.useLocationState();

  return (
    // @TODO: footer should be a minimum of stuck to the bottom of the window (shouldn't be any space after it)
    <View style={styles.container}>
      <View style={styles.footerInner}>
        <TouchableOpacity
          onPress={() => {
            Linking.openURL('https://oakwoodsc.com'); // @TODO: onhover would be nice to see destination
          }}
        >
          <Image
            style={styles.footerImage}
            source={require('@assets/img/oakwood_logo_small.png')}
            alt='oakwood logo'
          />
        </TouchableOpacity>
        <Text style={styles.text}>Wrinkly is developed by Oakwood Software Consulting, Inc. © {dateFnsFormat(new Date(), 'yyyy')}</Text>
      </View>
      <Legal isOpen={locationState.hash === '#terms_and_privacy'} />
    </View>
  );
};

export default Footer;
